import SpecialNumberTextField from './SpecialNumberTextField';

const SpecialNumberNameField = (props) => (
    <SpecialNumberTextField
        {...props}
        name="name"
        label="Name"
        placeholder="Enter special number name"
    />
);

export default SpecialNumberNameField;
